import { api } from '../core';
import { TOOLKIT_TAG } from '../constants';
import { setToolkitData } from '@/store/slices/toolkit';
import { handleQueryLifecycle } from '../utils';

export interface ToolkitTool {
  description: string;
  prompt: string;
  toolId: string;
  toolName: string;
}

export interface ToolkitGroup {
  groupTitle: string;
  tools: ToolkitTool[];
}

export interface ToolkitGroupCollection {
  collectionTitle: string;
  toolGroups: ToolkitGroup[];
}

export interface GetToolkitResponse {
  toolkitGroupCollections: ToolkitGroupCollection[];
  userTools: ToolkitTool[];
}

type GetToolkitProps = {
  abortController?: AbortController;
};

const getToolkitApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToolkit: builder.query<GetToolkitResponse, GetToolkitProps>({
      query: ({ abortController = new AbortController() }: GetToolkitProps) => ({
        url: `toolkit`,
        method: 'GET',
        signal: abortController.signal,
      }),
      providesTags: () => [TOOLKIT_TAG],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, (data) => {
          dispatch(
            setToolkitData({
              toolkitGroupCollections: data.toolkitGroupCollections ?? [],
              userTools: data.userTools ?? [],
            }),
          );
        });
      },
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useGetToolkitQuery } = getToolkitApi;
